import React from 'react';
import MultiClamp from 'react-multi-clamp';

import { PinO, Clear } from '@crehana/icons';

import { Avatar, TextLink, colors, StringParser } from '@crehana/ui';

import unescapeChars from 'Shared/StringParser/unescapeChars';

import { ChatNode } from 'Jsx/CrehanaLive/graphql/types/ChatNode';
import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

interface PinnedMessageProps {
  chatPinned: ChatNode;
  areActionsEnabled?: boolean;
  hasModeratorPermission: boolean;
  unpinMessage: any;
}

const PinnedMessage: React.FC<PinnedMessageProps> = ({
  chatPinned,
  areActionsEnabled,
  hasModeratorPermission,
  unpinMessage,
}) => {
  const { t } = useCrehanaLiveTranslations();
  const [isOpenPinMessage, setIsOpenPinMessage] = React.useState(false);
  const [needClamp, setNeedClamp] = React.useState(true);

  return (
    <div className="absolute top-0 left-0 right-0 p-12 bg-primary-light z-7">
      <div className="flex items-center justify-between">
        {chatPinned.user ? (
          <div className="flex items-center">
            <Avatar
              alt={chatPinned.user.username}
              src={chatPinned.user.thumbnailUrl}
              size={16}
              href={chatPinned.user.profileUrl || undefined}
              // @ts-ignore
              target="_blank"
              rel="noopener noreferer"
              className="mr-8"
            />
            <a
              className="mr-8 tw-font-semibold font-body4 text-white"
              href={chatPinned.user.profileUrl || undefined}
              // @ts-ignore
              target="_blank"
              style={{ minWidth: 80 }}
              rel="noreferrer"
            >
              @{chatPinned.user.username}
            </a>
            <PinO size={16} color={colors.primaryDark} className="mr-8" />
            <p className="text-primary-dark font-caption"> Fijado </p>
          </div>
        ) : null}
        {areActionsEnabled && hasModeratorPermission ? (
          <button
            type="button"
            className="outline-none"
            onClick={() => unpinMessage(chatPinned.originalId)}
          >
            <Clear size={16} color="#fff" />
          </button>
        ) : null}
      </div>
      {isOpenPinMessage || !needClamp ? (
        <StringParser
          className="break-words"
          textType="legals"
          isDark
          plainText={chatPinned.message || ''}
        />
      ) : (
        <p className="break-all font-legals text-white">
          <MultiClamp
            clamp={2}
            disableCssClamp
            onClampStart={e => setNeedClamp(e.needClamp)}
          >
            {unescapeChars(chatPinned.message)}
          </MultiClamp>
        </p>
      )}

      {needClamp && (
        <TextLink onClick={() => setIsOpenPinMessage(prev => !prev)}>
          Ver {isOpenPinMessage ? t('LESS') : t('MORE')}
        </TextLink>
      )}
    </div>
  );
};

export default PinnedMessage;
